import { useCallback, useMemo } from "react";

import { getToday } from "@/services/Utils";
import { enqueueExcelExport } from "@/services/exportQueue.service";
import useFilterStore from "@/stores/useFilterStore";

export function useOAExport(appliedFilterParams, tableState) {
	const { estate_id, estate_parent_id, search, parameter } = useFilterStore((state) => state.filter);

	const queueExcelDownload = useCallback(({ url, name, params, api }) => {
		enqueueExcelExport({
			url,
			name,
			params,
			api,
		});
	}, []);

	const mappedExportParams = useMemo(
		() => ({
			page: tableState.page,
			paginate: tableState.per_page,
			order: tableState.order_by,
			orderType: tableState.order_dir,
			estate_parent_id,
			estate_id,
			search,
			parameter,
			appOrderFilter: appliedFilterParams.code_oa || "",
			appOrdersStateFilter: Array.isArray(appliedFilterParams.status) ? appliedFilterParams.status.join(",") : appliedFilterParams.status || "",
			typeFilter: Array.isArray(appliedFilterParams.type) ? appliedFilterParams.type.join(",") : appliedFilterParams.type || "",
			dateFilter: appliedFilterParams.date_start || "",
			dateToFilter: appliedFilterParams.date_end || "",
		}),
		[appliedFilterParams, estate_id, estate_parent_id, parameter, search, tableState.order_by, tableState.order_dir, tableState.page, tableState.per_page],
	);

	const handleExportOA = useCallback(() => {
		queueExcelDownload({
			url: "/client/application_orders/excel",
			name: `ordenes_aplicacion_${getToday()}.xlsx`,
			params: mappedExportParams,
		});
	}, [mappedExportParams, queueExcelDownload]);

	const handleExportFieldBook = useCallback(() => {
		queueExcelDownload({
			url: "/client/application_orders/book_field/excel",
			name: `cuaderno_de_campo_${getToday()}.xlsx`,
			params: mappedExportParams,
		});
	}, [mappedExportParams, queueExcelDownload]);

	return {
		handleExportOA,
		handleExportFieldBook,
	};
}
